"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { useElements } from '../useElements.mjs';

function useFieldMappingInstances(query) {
  const { ...rest } = useElements(
    "field-mapping-instances",
    query
  );
  return {
    fieldMappingInstances: rest.items,
    ...rest
  };
}

export { useFieldMappingInstances };
